const data = [];
export default {
  // 定义 model 的初始 state

  name: 'app',
  state: {
    routes: data,
    menuData: [],
    buttonData: [],
    currentRoute: {},
    isRefresh: null,
    basicInformation: {
      userInf: {
        organizeName: '',
        verifyState: '',
      },
      organizationData: [],
    },
    appConfig: {
      title: '',
      copyright1: '',
      copyright2: '',
      copyright3: '',
      title_1: '',
      link1: '',
      link2: '',
      link3: '',
      icon: {
        logo: '',
        logo1: '',
        logo2: '',
      },
    },
  },
  // 定义处理该模型副作用的函数
  effects: (dispatch) => ({
    // async getUserInfo() {
    //   await delay(1000);
    //   dispatch.user.update({
    //     name: 'taobao',
    //     id: '123',
    //   });
    // },
  }),
  // 定义改变该模型状态的纯函数
  reducers: {
    updateStates(prevState, { payload }) {
      return {
        ...prevState,
        ...payload,
      };
    },
  },
};
